import { render } from "./PixelFormModal.vue?vue&type=template&id=25765d10"
import script from "./PixelFormModal.vue?vue&type=script&lang=js"
export * from "./PixelFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__